import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51aa7536"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "64 64 896 896",
  focusable: "false",
  "data-icon": "check",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createBlock(_component_a_tooltip, {
    title: (_ctx.title && _ctx.title) || undefined
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _mergeProps({
        class: _ctx.className,
        style: _ctx.disabled ? _ctx.disableStyle : null
      }, _ctx.$attrs), [
        _hoisted_1,
        _createElementVNode("span", {
          role: "img",
          "aria-label": "check",
          class: "anticon anticon-check select-icon",
          style: _normalizeStyle({ display: _ctx.checked ? 'block' : 'none' })
        }, _hoisted_3, 4)
      ], 16)
    ]),
    _: 1
  }, 8, ["title"]))
}